// extracted by mini-css-extract-plugin
module.exports = {"promotionalFeatures":"FeatureMessages_promotionalFeatures__IO47E"};